import React, { useEffect, useRef, useState } from 'react';
import { verifyTurnstile } from '../../services/Auth/Autenticacion';
import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';

const Turnstile = React.forwardRef((props, ref) => {
  const { onChange, onTurnstileValidado, onError } = props;
  const [turnstileLoaded, setTurnstileLoaded] = useState(false);
  const widgetIdRef = useRef(null);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const esMobile = matches ? false : true;

  const handleChange = (token) => {
    onChange();
    validateToken(token);
  };

  const validateToken = async (token) => {
    try {
      const result = await verifyTurnstile(token);
      if (result) {
        onTurnstileValidado(true);
      }
    } catch (err) {
      onTurnstileValidado(false);
      onError(err);
      resetTurnstile();
    }
  };

  const onTurnstileResponseExpiry = () => {
    onTurnstileValidado(false);
  };

  const onTurnstileError = (e) => {
    onTurnstileValidado(false);
    onError(e);
    resetTurnstile();
  };

  const resetTurnstile = () => {
    if (window.turnstile) {
      window.turnstile.reset(widgetIdRef.current);
    }
  };

  const turnstileCallback = () => {
    if (!turnstileLoaded) {
      widgetIdRef.current = window.turnstile.render('#cf-turnstile', {
        sitekey: props.sitekey,
        theme: 'light',
        size: 'flexible',
        callback: handleChange,
        'expired-callback': onTurnstileResponseExpiry,
        'error-callback': onTurnstileError,
      });
      setTurnstileLoaded(true);
    }
  };

  useEffect(() => {
    window.turnstileCallback = turnstileCallback;

    const loadScriptByURL = (id, url) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.id = id;
        script.async = true;
        script.defer = true;

        document.body.appendChild(script);
      } else {
        if (isScriptExist) turnstileCallback();
      }
    };

    loadScriptByURL(
      'turnstile-key',
      'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=turnstileCallback&render=explicit',
    );
  }, [window.turnstile]);

  return (
    <Box
      ref={ref}
      sx={{
        display: 'flex',
        justifyContent: esMobile ? 'center' : 'flex-start',
        ...props.sx || {},
      }}
    >
      <div id='cf-turnstile' style={{ width: '100%' }} />
    </Box>
  );
});

export default Turnstile;
